<script lang="ts" setup>
import type { TravelOrderDto, TravelOrderPayment } from "@/api/trips/dto/trip.dto";
import { useI18n } from "vue-i18n";
import { TravelOrderPaymentTypeLabel } from "@/constants/travelOrder";
import { useTravelOrder } from "@/composables/reactive/useTravelOrder";
import { computed, toRef } from "vue";

const props = defineProps<{
  payments: TravelOrderPayment[];
  travelOrder: TravelOrderDto;
  isCancelled: boolean;
}>();

const { t } = useI18n();

const { totalPaymentsAmount } = useTravelOrder(toRef(props, "travelOrder"));

const travelOrderListClass = computed(() => {
  if (props.isCancelled) {
    return "bg-red-lighten-5";
  }

  return "bg-white";
});
</script>

<template>
  <v-list :class="travelOrderListClass">
    <v-list-item v-for="(payment, index) of payments" :key="payment.tempId" min-height="16">
      <div class="d-flex align-center justify-space-between" data-qa="payment-row">
        <div class="d-flex align-center font-size-12 col-gap-1">
          <span class="text-grey-darken-1">{{ t("general.payment") }}#{{ index + 1 }}</span>

          <span>-</span>

          <span v-if="payment.type">{{ TravelOrderPaymentTypeLabel[payment.type] }}</span>
        </div>

        <span class="text-grey-darken-2 font-weight-500" data-qa="payment-value">{{ payment.amount }}$</span>
      </div>
    </v-list-item>

    <v-list-item class="mt-1" min-height="16">
      <div class="d-flex justify-end">
        <span class="text-grey-darken-2">{{ t("general.total-rate") }}:</span>
        <span class="text-grey-darken-3 font-weight-500 ml-1" data-qa="total-rate">{{ totalPaymentsAmount }}$</span>
      </div>
    </v-list-item>
  </v-list>
</template>

<style lang="scss" scoped></style>
